import { render } from "./LoginSettingsTab.vue?vue&type=template&id=1fbbefa7"
import script from "./LoginSettingsTab.vue?vue&type=script&lang=js"
export * from "./LoginSettingsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__